import React from "react";
import { Box, Typography, Grid, Avatar } from "@mui/material";
import "flag-icons/css/flag-icons.min.css"; // For country flags
import ReactCountryFlag from "react-country-flag";

const country_code_mapping = {
  turkey: "tr",
  nigeria: "ng",
  indonesia: "id",
  switzerland: "ch",
  "new zealand": "nz",
  italy: "it",
  hungary: "hu",
  russia: "ru",
  china: "cn",
  korea: "kr",
  "czech republic": "cz",
  norway: "no",
  sweden: "se",
  usa: "us",
  pakistan: "pk",
  netherlands: "nl",
  unknown: "un",
  romania: "ro",
  brazil: "br",
  austria: "at",
  uk: "gb",
  australia: "au",
  ireland: "ie",
  germany: "de",
  singapore: "sg",
  canada: "ca",
  portugal: "pt",
  finland: "fi",
  "saudi arabia": "sa",
  argentina: "ar",
  spain: "es",
  croatia: "hr",
  "united arab emirates": "ae",
  greece: "gr",
  india: "in",
  belgium: "be",
  chile: "cl",
  france: "fr",
  slovakia: "sk",
  vietnam: "vn",
  israel: "il",
  "south africa": "za",
  mexico: "mx",
  peru: "pe",
  kenya: "ke",
  malaysia: "my",
  iceland: "is",
  poland: "pl",
  taiwan: "tw",
  "hong kong": "hk",
  japan: "jp",
  denmark: "dk",
  philippines: "ph",
  thailand: "th",
};

// Ticker Row Component
const TickerRow = ({ticker, handleClickTickerSelect }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "10px 10px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      className="ticker-row"
      onClick= {(e)=> handleClickTickerSelect(e, ticker)}
    >
      <Box
        sx={{
          display: "flex",
          maxWidth: "200px",
          minWidth: "175px",
          overflowX: "auto",
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontSize: 14,
            overflow: "hidden",
            maxWidth: "125px",
            background: "none",
            overflowWrap: "break-word",
          }}
        >
          {ticker?.code}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          maxWidth: "650px",
          minWidth: "600px",
          overflowX: "auto",
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontSize: 14,
            overflow: "hidden",
            maxWidth: "575px",
            background: "none",
            overflowWrap: "break-word",
          }}
        >
          {ticker?.name}
        </Typography>
      </Box>

      <Grid container alignItems="center" justifyContent="flex-end">
        <Typography
          variant="body2"
          sx={{ color: "#aaa", marginRight: 2, fontSize: 12 }}
        >
          {ticker?.type}
        </Typography>
        <Typography variant="body2" sx={{ color: "#aaa", marginRight: 2 }}>
          {ticker?.exchange?.toUpperCase()}
        </Typography>
        <ReactCountryFlag
          countryCode={
            country_code_mapping[ticker?.country?.toLowerCase()] || ticker?.country?.slice(0, 2)
          }
          style={{ fontSize: "2em" }}
        />
      </Grid>
    </Box>
  );
};

export default TickerRow;
